<template>
  <a-card class="password-reset-form-card">
    <ValidationObserver ref="observer">
      <a-form
        :label-width="80"
        slot-scope="{ validate }"
        @submit.prevent="validate().then(handleSubmit)"
      >
        <h2 class="title">{{ labels.title }}</h2>
        <Input
          v-model="form.password"
          ref="password"
          type="password"
          rules="required|min:6"
          vid="password"
          :placeholder="labels.form1.password.placeholder"
          size="large"
          :allowClear="true"
          :label="labels.form1.password.label"
        />
        <Input
          v-model="form.password_confirmation"
          type="password"
          rules="required|confirmed:password"
          vid="password_confirmation"
          :placeholder="labels.form1.password_confirmation.placeholder"
          size="large"
          :allowClear="true"
          :label="labels.form1.password_confirmation.label"
        />
        <a-form-item style="text-align: right">
          <a-button
            type="default"
            html-type="submit"
            :loading="submitting"
            :disabled="submitting"
            size="large"
            class="btn-reset"
            @click.prevent="validate().then(handleSubmit)"
          >
            <span>{{ labels.form1.submit }}</span>
          </a-button>
        </a-form-item>
        <a-form-item style="text-align: center">
          <a-button
            type="default"
            size="large"
            class="back-link"
            @click.prevent="handleBack"
            block
            ghost
          >
            {{ labels.form1.cancel }}
          </a-button>
        </a-form-item>
      </a-form>
    </ValidationObserver>
  </a-card>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import Input from "@/components/core/VeeValidateForm/Input";
import labels from "@/utils/labels";
import _ from "lodash";
import { mapActions } from "vuex";
const initialState = {
  password: "",
  password_confirmation: "",
};
export default {
  name: "PasswordResetForm",
  components: {
    ValidationObserver,
    Input,
  },
  data() {
    return {
      form: _.cloneDeep(initialState),
      submitting: false,
      labels: labels.passwordResetForm,
    };
  },
  methods: {
    ...mapActions("clientAuth", ["handlePasswordReset"]),
    async handleSubmit() {
      try {
        let code = this.$route.params.code;
        await this.handlePasswordReset({ ...this.form, code });
        this.$success({
          title: this.labels.form1.success,
          centered: true,
          closable: false,
          maskClosable: false,
          keyboard: false,
          class: "success-modal",
          okText: this.labels.form1.okText,
          autoFocusButton: "ok",
          onOk: () => {
            this.form = _.cloneDeep(initialState);
            this.$refs?.observer?.reset();
            this.$router.push({ name: "login" });
          },
          onCancel: () => {
            this.form = _.cloneDeep(initialState);
            this.$refs?.observer?.reset();
            this.$router.push({ name: "login" });
          },
        });
      } catch (error) {
        this.$error({
          title: this.labels.error,
          content:
            error?.response?.data?.message ||
            error?.response?.message ||
            error.message,
          centered: true,
        });
      } finally {
        this.submitting = false;
      }
    },
    handleBack() {
      this.$router.push({ name: "login" });
    },
  },
};
</script>
<style lang="scss">
@import "~@/assets/scss/variable";
.password-reset-form-card {
  background-color: var(--card-shop-bg);
  border-color: var(--card-shop-shadow);
  box-shadow: 0 0 2px var(--card-shop-shadow);
  padding: 3.125rem;
  border-radius: 8px;
  max-width: 481px;
  @media screen and (max-width: $screen-mobile) {
    padding: 2.125rem 1rem;
  }
  .title {
    font-family: "Exo 2", sans-serif;
    color: var(--text);
    font-weight: 400;
    margin: 0;
    line-height: 1.3;
    word-break: break-word;
    font-size: 2rem;
    margin-bottom: 1rem;
    text-align: center;
  }
  .ant-card-body {
    padding: 0;
  }
  .ant-form label {
    font-size: 0.875rem;
    color: var(--text);
    font-family: "Roboto", sans-serif;
  }
  .ant-input {
    background-color: var(--input-bg);
    height: 3.75rem;
    color: var(--text);
    &:active,
    &:focus,
    &:hover {
      border-color: var(--text-muted);
    }
  }
  .ant-input-affix-wrapper {
    .ant-input:not(:first-child) {
      padding-left: 2.8125rem;
    }
    .ant-input-prefix {
      color: color(--white);
      font-size: 1.375rem;
      font-family: "Roboto", sans-serif;
    }
    .ant-input-clear-icon,
    .ant-input-password-icon,
    .ant-input-textarea-clear-icon {
      color: var(--text);
    }
  }

  .has-error .ant-input-affix-wrapper .ant-input,
  .has-error .ant-input-affix-wrapper .ant-input:hover {
    background-color: var(--input-bg);
  }

  .btn-reset {
    color: var(--btn-text-secondary) !important;
    background-color: var(--btn-bg-secondary);
    border-color: var(--btn-bc-secondary);
    height: 51px;
    padding: 0 1.75rem;
    width: 100% !important;
  }

  .back-link {
    @extend .btn-reset;
    color: var(--link);
  }
}

input:-internal-autofill-selected {
  background-color: var(--input-bg) !important;
  border-color: var(--text-active) !important;
  color: var(--text-muted) !important;
}

// animation
.success-modal {
  font-size: 16px;
  .ant-modal-content {
    background-color: var(--modal-bg) !important;
    box-shadow: 0 1px 3px 3px var(--modal-shadow);
    .ant-modal-confirm-title {
      color: var(--text) !important;
    }
    .ant-modal-confirm-content {
      color: var(--text) !important;
      p {
        font-size: 16px;
        text-align: justify;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .ant-modal-confirm-btns {
      .ant-btn {
        background-color: var(--btn-bg-secondary) !important;
        border-color: var(--btn-bc-secondary) !important;
        color: var(--btn-text-secondary) !important;
        &:hover,
        &:focus,
        &:active {
          background-color: var(--btn-bg-secondary) !important;
          border-color: var(--btn-bc-secondary) !important;
          color: var(--btn-text-secondary) !important;
        }
        &.ant-btn-primary {
          background-color: var(--btn-bg-primary) !important;
          border-color: var(--btn-bc-primary) !important;
          color: var(--btn-text-primary) !important;
          &:hover {
            background-color: var(--btn-bg-primary) !important;
            border-color: var(--btn-bc-primary) !important;
            color: var(--btn-text-primary) !important;
          }
        }
      }
    }
  }
}
</style>
